import i18n from "config/i18next";

i18n.addResources("es", "polygonPricing", {
  config: "Configuración de viaje",
  colect: "Colecta del viaje",
  colectBonus: "km por colecta",
  finished: "Entrega exitosa",
  finishedBonus: "km entre entregas",
  devolution: "Devolución exitosa",
  devolutionBonus: "km por devolución",
  rain: "Bonus por lluvia",
  pricing: "Pricing",
  tiersTitle: "Tiers",
  tierName: "Tier",
  tierBase: "Base",
  tierPrice: "Multiplicador",
  dayTiers: "Diario",
  weekTiers: "Semanal",
  addRow: "Nueva Fila",
  divisa: "$",
  assuredTitle: "Asegurado",
  assuredValue: "Asegurado por hora",
  presenteeism: "Presentismo",
  minimumAmount: "Cantidad mínima de transacciones",
  minimumPercentage: "Porcentaje mínimo de transacciones",
  percentageValidation: "Debe ser menor o igual al 100 %",
  errorMessage1: "Campo requerido",
  errorMessage2: "Ingresá un número mayor a 0",
  errorMessage3: "Revisá los datos ingresados e intentá nuevamente",
});
